













import { Component, Provide, Vue } from 'vue-property-decorator';

@Component
export default class ElementAccountButton extends Vue {
  @Provide() pending: boolean = false;

  get doctor() {
    return this.$pdc.doctor!.current;
  }

  get initials() {
    return this.doctor.firstName.slice(0, 1) + this.doctor.lastName.slice(0, 1);
  }
}
